module.exports = __webpack_public_path__ + "static/media/rectangle-8.8ac73b28.svg";